import useFeature from '@/hooks/use-feature.hook';
import { Stack } from '@mui/material';
import classNames from 'classnames';
import { FC, ReactNode } from 'react';
import { createUseStyles } from 'react-jss';
import InlineToast from '../toasts/inline';
import { MetabaseContainerProps } from './helpers';

const useStyles = createUseStyles({
  metabaseContainer: {
    overflow: 'hidden',
    '& *, & *::before, & *::after': {
      boxSizing: 'border-box !important',
    },
    '& .metabase-embed': {
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      minHeight: 0,
      flex: 1,
    },
    '& .metabase-embed .mb-mantine-Flex-root': {
      maxHeight: '100% !important',
    },
  },
  metabaseDrawerDashboard: {
    '& *, & *::before, & *::after': {
      minHeight: '0 !important',
    },
    '& header': {
      border: 'none !important',
    },
    '& [data-testid="dashboard-parameters-and-cards"]': {
      padding: 0,
    },
    // override Metabase's FullWidthContainer which pushes the cards and the filter bar right of the surrounding drawer content
    '& [data-element-id="dashboard-cards-container"], & [data-testid="dashboard-parameters-widget-container"]':
      {
        paddingLeft: 0,
        paddingRight: 0,
      },
    '& [data-testid="dashboard-header"]': {
      display: 'none',
    },
    margin: '-12px 0 8px',
    '& .metabase-embed': {
      overflow: 'auto',
      padding: '8px 0',
    },
  },
});

interface Props extends MetabaseContainerProps {
  children: ReactNode;
}
const MetabaseContainer: FC<Props> = ({ children, isDrawer = false }) => {
  const styles = useStyles();
  const { canViewCharts } = useFeature();

  if (!canViewCharts) {
    return (
      <InlineToast message="Insights are under maintenance and will be back soon" level="warning" />
    );
  }

  return (
    <Stack
      height="100%"
      minHeight={0}
      className={classNames(styles.metabaseContainer, isDrawer && styles.metabaseDrawerDashboard)}
    >
      {children}
    </Stack>
  );
};
export default MetabaseContainer;
